import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { apiGetQuoteAssumDetailInfo } from '../../../../src/api/combineApi';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AssumptionQuoteView = function AssumptionQuoteView(props) {
  var className = props.className,
      quoteId = props.quoteId;

  var _useState = useState([]),
      infoList = _useState[0],
      setInfoList = _useState[1];
  /**
   * requests
   */


  var requestAssumQuoteInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _res$data;

      var _yield$apiGetQuoteAss, _yield$apiGetQuoteAss2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (quoteId) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return apiGetQuoteAssumDetailInfo({
                quoteId: quoteId
              });

            case 4:
              _yield$apiGetQuoteAss = _context.sent;
              _yield$apiGetQuoteAss2 = _slicedToArray(_yield$apiGetQuoteAss, 1);
              res = _yield$apiGetQuoteAss2[0];
              setInfoList((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.items) || []);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestAssumQuoteInfo() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * effects
   */


  useEffect(function () {
    if (quoteId) {
      requestAssumQuoteInfo();
    }
  }, [quoteId]);
  return (infoList === null || infoList === void 0 ? void 0 : infoList.length) > 0 ? /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col rounded-lg border border-[#d6d6d6]', className),
    children: /*#__PURE__*/_jsxs(Accordion, {
      sx: {
        '&.MuiAccordion-root': {
          boxShadow: 'none'
        },
        '&.Mui-expanded': {
          margin: 0
        }
      },
      className: "rounded-[10px]",
      defaultExpanded: true,
      children: [/*#__PURE__*/_jsx(AccordionSummary, {
        expandIcon: /*#__PURE__*/_jsx(ExpandMoreIcon, {}),
        "aria-controls": "assumptions-content",
        id: "assumptions-header",
        sx: {
          '& .MuiAccordionSummary-content': {
            margin: 0
          }
        },
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle1",
          className: "font-bold text-[#202020]",
          children: "View details of the assumption here."
        })
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-col space-y-2 px-4 pb-3",
        children: [/*#__PURE__*/_jsxs(Typography, {
          variant: "subtitle1",
          className: "font-medium leading-5 text-[#202020]",
          children: ["Based on the information you provided, we've made certain ", /*#__PURE__*/_jsx("span", {
            className: "font-bold",
            children: "assumptions"
          }), " about your business risk profile."]
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle1",
          className: "font-medium leading-5 text-[#202020]",
          children: "The final quote may be subject to change if any details are adjusted."
        }), /*#__PURE__*/_jsx(Typography, {
          variant: "subtitle1",
          className: "font-bold leading-5 text-[#202020]",
          children: "You can modify these assumptions on the Summary page."
        }), infoList.length > 0 && /*#__PURE__*/_jsx(Box, {
          className: "flex flex-col px-4",
          children: /*#__PURE__*/_jsx("ul", {
            className: "list-disc",
            children: infoList.map(function (item, index) {
              return /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "subtitle1",
                  className: "font-bold text-[#202020]",
                  children: item.text
                }, index)
              }, index);
            })
          })
        })]
      })]
    })
  }) : null;
};